import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { Modal, ModalBody } from 'reactstrap';
import FeedbackComponent from '../email/feedbackComponent';
import moment from 'moment';
import { CircularProgressbar } from 'react-circular-progressbar';
import logo from '../../assets/img/logos/simple events logo.png';
import PagePreviewFrame from '../../views/pages/components/pagePreviewFrame';
import * as IFrame from 'react-iframe-form';

let refreshTimeInterval = null;

const ENV =
    process.env.NODE_ENV === 'production'
        ? window.location.href.includes('planner.simple.events') ? `https://admin-api.simple.events/` : `https://beta-api.simple.events/`
        : `http://${window.location.hostname}:5015/`;


class ShareablePageModule extends Component {
    constructor(props) {
        super(props);
        const { match: { params } } = this.props;

        const customFields = [
            {
                text: 'Organization Name',
                value: '{{orgName}}',
                label: 'Organization Name'
            }
        ];
        this.state = {
            selectedSection: 0,
            editedPage: {},
            editing: false,
            errorMessage: false,
            loading: true,
            editCount: 0,
            editedPostData: {},
            focusedComponent: -1,
            detailsExpanded: false,
            customFields: customFields,
            feedbackPanelOpen: false,
            feedbackPanelExpanded: false,
            componentDetailsExpanded: true,
            newThread: null,
        };
        this.feedbackComponentRef = React.createRef();
    }

    componentDidMount() {
        const { page, postData, keyedMetadata, keyedData } = this.props;
        const parameters = page.parameters ? [...page.parameters] : [];
        keyedMetadata.forEach((option) => {
            !parameters.includes(option) && parameters.push(option);
        })
        const metadataOptions = [];
        keyedData &&
            Object.keys(keyedData).forEach((key) => {
                const layer1 = keyedData[key];
                if (typeof layer1 === 'object') {
                    Object.keys(layer1).forEach((key2) => {
                        const layer2 = layer1[key2];
                        const k2 = key2.substring(0, 1) + key2.substring(1);
                        if (typeof layer2 === 'object') {
                            Object.keys(layer2).forEach((key3) => {
                                const layer3 = layer2[key3];
                                const k3 = key3.substring(0, 1) + key3.substring(1);
                                if (
                                    key !== '_defaultLabel' &&
                                    key2 !== '_defaultLabel' &&
                                    key3 !== '_defaultLabel'
                                ) {
                                    metadataOptions.push({
                                        label: `${layer1._defaultLabel} ${layer2._defaultLabel} ${layer3}`,
                                        value: `{{${key}${k2}${k3}}}`,
                                        text: `${key}${k2}${k3}`
                                    });
                                }
                            });
                        } else {
                            if (key !== '_defaultLabel' && key2 !== '_defaultLabel') {
                                metadataOptions.push({
                                    label: `${layer1._defaultLabel} ${layer2}`,
                                    value: `{{${key}${k2}}}`,
                                    text: `${key}${k2}`
                                });
                            }
                        }
                    });
                } else {
                    if (key !== '_defaultLabel') {
                        metadataOptions.push({ label: layer1, value: key, text: `{{${key}}}` });
                    }
                }
            });

        this.setState({ editedPage: { ...JSON.parse(JSON.stringify(page)), parameters: parameters }, editedPostData: postData, loading: false, customFields: metadataOptions }, () => {
            this.refreshPage();
        });

        window.addEventListener('message', (ev) => {
            if (ev.data.type == 'component-clicked' && this.state.editedPage.partials) {
                const componentId = ev.data.componentId;
                if (componentId >= 0) {
                    this.setState({
                        focusedComponent: componentId,
                    });
                }
            }

            if (ev.data.type == 'thread-posted') {
                this.addNewThread(ev.data);
            }
            if (ev.data.type == 'thread-repositioned') {
                const { newThread } = this.state;
                if (newThread) {
                    this.setState({ newThread: { ...newThread, coordinates: ev.data.coordinates } });
                }
            }
            if (ev.data.type == 'comment-badge-clicked') {
                let threadId = ev.data.threadId;
                this.selectThread(threadId);
            }
            if (typeof ev.data !== 'object') return;
            if (!ev.data.type) return;
            if (ev.data.type !== 'button-click') return;
            if (!ev.data.message) return;
        });
    }

    addNewThread = (pinnedMetadata) => {
        const { feedbackPanelOpen } = this.state;
        const { authenticatedUser } = this.props;

        const newThreadObject = {
            author: { sharedUserId: authenticatedUser._id },
            message: '',
            counter: pinnedMetadata.commentNumber,
            comments: [],
            coordinates: {
                x: pinnedMetadata.clickPosition.x,
                y: pinnedMetadata.clickPosition.y,
            }
        };
        this.setState({ feedbackPanelOpen: true, newThread: newThreadObject });
    }

    updateEditedPage = (data, callback) => {
        this.setState({ editing: true, editedPage: data }, callback);
    };

    handleNewThreadOnChange = (objChange) => {
        this.setState({ newThread: { ...this.state.newThread, ...objChange } });
    }

    createNewThread = async () => {
        this.props.addNewThread(this.state.newThread, () => {
            this.setState({ newThread: null, editCount: this.state.editCount + 1 });
        });
    }

    deleteThread = (threadId, callback) => {
        this.props.patchThread(threadId, { deleted: true }, () => {
            this.setState({ editCount: this.state.editCount + 1 });
            callback && callback();
        });
    }

    refreshPage = () => {
        if (this.state.editCount > 0) {
            this.setState({ refreshTimeRemaining: 1.5 });
            if (!refreshTimeInterval) {
                refreshTimeInterval = setInterval(() => {
                    if (this.state.refreshTimeRemaining > 0) {
                        this.setState({ refreshTimeRemaining: this.state.refreshTimeRemaining - 0.1 });
                    } else {
                        this.setState({ editCount: this.state.editCount + 1 }, () => { this.focusComponent(this.state.focusedComponent) });
                        clearInterval(refreshTimeInterval);
                        refreshTimeInterval = null;
                    }
                }, 100);
            }
        } else {
            this.setState({ editCount: this.state.editCount + 1 }, () => { this.focusComponent(this.state.focusedComponent) });
        }
    };

    focusComponent = (componentIndex) => {
        const previewFrame = document.getElementsByName('PagePreviewFrame')[0];

        if (previewFrame && previewFrame.contentWindow) {
            componentIndex > -1
                ? previewFrame.contentWindow.postMessage(
                    {
                        type: 'focusComponent',
                        componentIndex: componentIndex
                    },
                    '*'
                )
                : previewFrame.contentWindow.postMessage(
                    {
                        type: 'unfocus'
                    },
                    '*'
                );
        }
        this.setState({ focusedComponent: componentIndex });
    }

    cancelEdit = () => {
        this.setState({
            editedPage: this.props.page,
            editing: false
        });
    }

    toggleSection = (section) => {
        const { feedbackPanelOpen } = this.state;
        switch (section) {
            case 'feedback':
                this.setState({ feedbackPanelOpen: !feedbackPanelOpen })
                break;
        }
    }

    selectThread = (threadId) => {
        if (this.feedbackComponentRef.current) {
            this.feedbackComponentRef.current.selectThread(threadId);
        }
        // Also open the feedback panel if it's not already open
        this.setState({ feedbackPanelOpen: true });
    }

    render() {
        const { isOpen, toggle, url, eventId, orgId } = this.props;
        const {
            editedPage,
            editCount,
            focusedComponent,
            detailsExpanded,
            editing,
            feedbackPanelOpen,
            componentDetailsExpanded,
            feedbackPanelExpanded,
            loading,
        } = this.state;

        const partials = editedPage.partials || [];
        let feedbackThreadsMap = [];
        if (this.props.feedbackThreads.length > 0) {
            feedbackThreadsMap = this.props.feedbackThreads.map(thread => {
                return {
                    id: thread._id,
                    counter: thread.counter,
                    coordinates: thread.coordinates
                };
            });
        }

        return (
            <Modal isOpen={isOpen} toggle={toggle} className="fullscreen" >
                <div className='modalHeader ph-20' style={{ borderBottom: '1px solid var(--background)' }}>
                    <div className='headerContainer' style={{ maxWidth: 'unset', minHeight: 60, height: 60 }}>
                        <div className="flex aic w-100">
                            <div className="navLogo" style={{ width: 'unset' }}>
                                <img src={logo} />
                            </div>
                            <div className='flex ml-20 aic' style={{}}>
                                <div style={{ textAlign: 'center' }}>
                                    <h2>{this.props.event ? this.props.event.name : this.props.program ? this.props.program.name : ''}</h2>
                                    <div className='flex aic '>
                                        <h4>Page</h4> <div className='mr-10 ml-10' style={{ fontSize: 12, lineHeight: 1 }}>|</div>
                                        <h3>{editedPage.title}</h3>
                                    </div>
                                </div>
                            </div>
                            {this.state.refreshTimeRemaining > 0 && (
                                <div className='flex aic'
                                    style={{ width: 20, height: 20, fontSize: 20, marginRight: 20 }}
                                >
                                    <CircularProgressbar
                                        value={this.state.refreshTimeRemaining}
                                        maxValue={1.5}
                                        text={this.state.refreshTimeRemaining.toFixed(0)}
                                        strokeWidth={12}
                                        counterClockwise={true}
                                    />
                                </div>
                            )}
                            <button onClick={this.props.closeReport} className='neu ml-a prim'>Logout</button>
                        </div>
                    </div>
                </div>
                <ModalBody className="modalBody">
                    <div className="editorWorkspace">
                        <div className='flex jcsb w-100 h-100'>
                            <div className='designerPreview'>
                                <div className="editorFrame w-100">
                                    <div className='pagePreviewContainer2' style={{ maxWidth: 1200 }}>
                                        {/*  <PagePreviewFrame
                                            ENV={ENV}
                                            renderURL={url}
                                            preview={true}
                                            pageProperties={this.state.editedPage}
                                            focusedComponent={this.state.focusedComponent}
                                            simulatedUser={{ value: this.props.authenticatedUser?._id }}
                                            simulatedSession={{ value: false }}
                                            renderOnly={true}
                                            editing={this.state.editCount}
                                            isSharedPage={true}
                                            feedbackThreads={feedbackThreadsMap}
                                        /> */}
                                        <IFrame.Form
                                            id="builderPreviewFrame"
                                            key={`template - ${editCount}`}
                                            name="PreviewFrame"
                                            config={{
                                                url, method: 'post',
                                                data: {
                                                    rendering: true,
                                                    partials: editedPage.partials,
                                                    ...(this.props.eventId ? { eventId: this.props.eventId } : {}),
                                                    feedbackThreads: feedbackThreadsMap,
                                                    eventId: eventId,
                                                    isSharedPage: true,
                                                    renderOnly: true,
                                                }
                                            }}
                                        />
                                    </div>
                                </div>
                                {partials.length == 0 && <div className='startCreatingPrompt'>
                                    <h4>This page is currently empty.</h4>
                                </div>}
                            </div>

                            <div style={{ overflowX: 'hidden', position: 'relative' }} className={`designerPanel p-0 right ${feedbackPanelOpen ? '' : 'closed'} ${feedbackPanelExpanded ? 'expanded' : ''}`}>
                                <div style={{ overflowX: 'hidden', overflowY: 'auto', padding: 25, paddingBottom: 60, height: 'calc(100vh - 120px)' }} className={`formInputsSection selected`}>
                                    <button onClick={() => this.toggleSection('feedback')} style={{ padding: 7, marginLeft: -7, marginTop: -7, fontSize: 16 }}><i className='las la-times'></i></button>

                                    {!loading &&
                                        <FeedbackComponent
                                            ref={this.feedbackComponentRef}
                                            componentSelected={focusedComponent !== -1 ? true : false}
                                            editedEmailTemplate={editedPage}
                                            focusedComponentIndex={focusedComponent}
                                            togglePanel={() => { }}
                                            expanded={componentDetailsExpanded}
                                            expandPanel={() => this.setState({ componentDetailsExpanded: !componentDetailsExpanded })}
                                            focusComponent={this.focusComponent}
                                            updateEmailComponent={() => { }}
                                            links={this.props.links}
                                            staticCustomFields={this.props.staticCustomFields}
                                            customFields={this.state.customFields}
                                            newThread={this.state.newThread}
                                            handleNewThreadOnChange={this.handleNewThreadOnChange}
                                            createNewThread={this.createNewThread}
                                            feedbackThreads={this.props.feedbackThreads}
                                            patchThread={this.props.patchThread}
                                            deleteThread={this.deleteThread}
                                            authenticatedUser={this.props.authenticatedUser}
                                        />}
                                </div>
                            </div>

                            {<div className='designerPanel side p-0' style={{ overflow: 'hidden', position: 'relative', minWidth: 100, width: 100 }} >
                                <div className='flex column jcc'>
                                    <div className={`flex column jcc aic c-pointer ${feedbackPanelOpen ? 'selectedSection' : ''} `} style={{ height: 100, position: 'relative' }} onClick={() => {
                                        this.toggleSection('feedback')
                                    }}>
                                        <i className='las la-comments mb-10' style={{ fontSize: 30 }}></i>
                                        <h5>Feedback</h5>
                                        {(() => {
                                            const openThreadsCount = this.props.feedbackThreads.filter(thread => !thread.deleted && (!thread.status || thread.status === 'open')).length;
                                            return openThreadsCount > 0 ? (
                                                <div style={{
                                                    position: 'absolute',
                                                    top: 10,
                                                    right: 20,
                                                    backgroundColor: '#FF586B',
                                                    color: 'white',
                                                    borderRadius: '50%',
                                                    width: 25,
                                                    height: 25,
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    fontSize: 12,
                                                    fontWeight: 'bold',
                                                    border: '2px solid white'
                                                }}>
                                                    {openThreadsCount}
                                                </div>
                                            ) : null;
                                        })()}
                                    </div>
                                </div>
                            </div>}
                        </div>
                    </div>
                </ModalBody>
            </Modal>
        );
    }
}

export default withRouter(ShareablePageModule);
